import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const BackLabel = styled.div`
  color: ${props => props.theme.colors.black};
  font-size: 10px;
  font-weight: bold;
  font-family: ${props => props.theme.fontSets.narrowRegular};
  ${props => props.theme.mediaQueries.tablet_big_down}{
    font-size: 18px;
    //margin-left: 2.6em;
  }
`;

export const BackLink = styled(Link)`
  text-decoration: none;
`;

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  ${props => props.isCup && props.isMobile && css`
    margin-bottom: 25px;
  `};
`;



// WEBPACK FOOTER //
// ./src/containers/VolleyCalendarChampionship/CalendarBar/styles.js